import logo from "../../../assets/images/neer_logo.svg";

export default function LoginWrapper({ children }) {
  return (
    <div className="login-page__container">
      <div className="login-auth">
        <div className="login-wrapper">
          <img
            className="login-logo"
            alt="NextEra Energy Services Logo"
            src={logo}
          />
          {children}
        </div>
      </div>
      <div className="login-splash" />
    </div>
  );
}
